/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseModulesManagementDashboard from "../../../components/CourseContentManagement/ModulesManagement";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const CourseModulesManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.courseContentManagement?.hasModuleManagementAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <CourseModulesManagementDashboard ROOT_URL={ROOT_URL} adminConfig={userConfig} />
    </>
  );
};

export default CourseModulesManagement;
